module.exports = __webpack_public_path__ + "img/hr-stone-path-u.b018a66f.png";